// © Microsoft Corporation. All rights reserved.

import { neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

const imageBgColor = "#F2F2F2";
const imageSize = "150px";
const imageMargin = "4px";
const mainPadding = "8px";

export const MediaInputStyles = {
    mediaInputContainer: {
        position: "relative",
        display: "flex",
        "justify-content": "center",
        "min-height": `calc(${imageSize} + ${mainPadding} * 2)`,
        padding: mainPadding,
        background: imageBgColor,
        "box-sizing": "border-box",
        "& .cwt-media-container": {
            display: "flex",
            "flex-wrap": "wrap",
            margin: imageMargin,
            "z-index": "1",

            "& .cwt-image-container": {
                display: "flex",
                position: "relative",
                "justify-content": "center",

                "& .cwt-image": {
                    width: imageSize,
                    height: imageSize,
                    "max-height": imageSize,
                    "object-fit": "scale-down",
                    margin: imageMargin,
                    background: neutralLayerCard,
                    "border-radius": "4px"
                },

                "& .cwt-button-container": {
                    display: "none",
                    "align-items": "center",
                    "justify-content": "space-around",
                    position: "absolute",
                    bottom: imageMargin,
                    width: `calc(100% - (${mainPadding} + ${imageMargin}) * 2)`,
                    padding: mainPadding,
                    background: "rgba(255, 255, 255, .55)",
                    "border-radius": "0",

                    "& .cwt-icon": {
                        cursor: "pointer",
                        "font-size": "20px",
                        color: neutralForegroundRest
                    }
                },

                "&:hover": {
                    "& .cwt-button-container": {
                        display: "flex"
                    }
                }
            }
        },

        "& .cwt-media-input": {
            position: "absolute",
            width: "100%",
            height: "100%",
            opacity: "0"
        },

        "& .cwt-add-image-icon": {
            color: neutralForegroundRest,

            "&:hover": {
                color: neutralForegroundRest
            },

            "& .cwt-icon-vector": {
                padding: "4px",
                border: "2px solid ",
                "border-color": neutralForegroundRest,
                "border-radius": "50%"
            }
        }
    }
};